import React, { useState, useEffect, useRef } from 'react';
import styles from '../CSS/AgentHome.module.css';

import { useNavigate } from 'react-router-dom';

import { useAuth } from "../AuthContext";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const AgentHome = () => {
    const { fetchData } = useAuth();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [records, setRecords] = useState([])

    const [balance, setBalance] = useState(0);
    const [remitted, setRemitted] = useState({
        amount: 0,
        no: 0
    });

    const [deposit, setDeposit] = useState({
        amount: 0,
        no: 0
    });

    const [withdraw, setWithdraw] = useState({
        amount: 0,
        no: 0
    });
    
    const [rate, setRate] = useState(0)
    const [symbol, setSymbol] = useState('')

    const navigate = useNavigate();


    const displayError = (message) => {
            setIsError(true);
            setErrorText(message);
    
            const timerId = setTimeout(() => {
                setIsError(false);
                setErrorText('');
            }, 1500);
    
            return () => clearTimeout(timerId);
        };
    
        const isFirstRun = useRef(true);
        async function getData() {
            setLoader(true);
    
            try {
                const data = await fetchData('/admin/agent/home');
                setLoader(false);
                
                setRate(data.rate)
                setSymbol(data.symbol)

                setBalance(data.balance);
                setRemitted(data.remitted);
                setDeposit(data.deposit);
                setWithdraw(data.withdraw);

                setRecords(data.records)
            } catch (error) {
                setLoader(false);
                displayError(error.message)
            }
        }
    
        useEffect(() => {
            if (isFirstRun.current) {
                getData();
                isFirstRun.current = false;
            }
        }, [])

    return (
        <div className={styles.dashboard}>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Dashboard</h1>
                </div>
                <div className={styles.right}>
                    <div className={styles.avatar}>U</div>
                </div>
            </div>

            <div className={styles['summary-container']}>
                <div className={styles['summary-card']}>
                    <p className={styles['summary-title']}>Available Balance</p>
                    <h2 className={styles['summary-amount']}>{balance} <span>{symbol}</span></h2>
                    <p className={styles['summary-sub']}>${balance * rate} USD</p>
                </div>
                <div className={`${styles['summary-card']} ${styles.small}`}>
                    <p className={styles['summary-title']}>Total Deposits</p>
                    <h2 className={styles['summary-amount']}>{deposit.amount} <span>{symbol}</span></h2>
                    <p className={styles['summary-sub']}>${deposit.amount * rate} USD</p>
                </div>
                <div className={styles['summary-card']}>
                    <p className={styles['summary-title']}>Total Withdrawals</p>
                    <h2 className={styles['summary-amount']}>{withdraw.amount} <span>{symbol}</span></h2>
                    <p className={styles['summary-sub']}>${withdraw.amount * rate} USD</p>
                </div>
                <div className={`${styles['summary-card']} ${styles.small}`}>
                    <p className={styles['summary-title']}>Total Remitted</p>
                    <h2 className={styles['summary-amount']}>{remitted.amount} <span>{symbol}</span></h2>
                    <p className={styles['summary-sub']}>${remitted.amount * rate} USD</p>
                </div>
                <div className={`${styles['summary-card']} ${styles.small}`}>
                    <p className={styles['summary-title']}>Commission</p>
                    <h2 className={styles['summary-amount']}>{balance * 0.08} <span>{symbol}</span></h2>
                </div>
            </div>

            <div className={styles['button-group']}>
                <button onClick={() => navigate('/records/payouts')}>Withdrawal Records</button>
                <button onClick={() => navigate('/records/deposits')}>Deposit Records</button>
                <button>Remit Records</button>
                <button onClick={() => navigate('/pending/deposit')}>Pending Deposits</button>
                <button onClick={() => navigate('/pending/withdrawal')}>Pending Withdrawals</button>
            </div>

            <div className={styles['daily-records']}>
                <h3>Daily Overview</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Deposit</th>
                            <th>Withdraw</th>
                            <th>Remit</th>
                            <th>Commission</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item.date}</td>
                                    <td>{symbol} {item.depositAmount}</td>
                                    <td>{symbol} {item.withdrawalAmount}</td>
                                    <td>{symbol} {item.remittedAmount}</td>
                                    <td>{symbol} {item.remittedAmount * 0.08}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AgentHome;
